module.exports = __webpack_public_path__ + "img/steuntje-dark.030036c1.png";